(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initBars = scope => scope.querySelectorAll("[data-announce]:not([data-ready])").forEach((bar => {
    bar.dataset.ready = "";
    const items = [ ...bar.querySelectorAll(".announce__item") ];
    if (items.length < 2) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    const interval = Number(bar.dataset.interval) || 5e3;
    let index = 0;
    let timer;
    let paused = false;
    const show = next => {
      const current = items[index];
      index = (next + items.length) % items.length;
      current.classList.add("is-leaving");
      current.classList.remove("is-active");
      current.setAttribute("aria-hidden", "true");
      current.querySelector("a")?.setAttribute("tabindex", "-1");
      setTimeout((() => current.classList.remove("is-leaving")), 500);
      const item = items[index];
      item.classList.add("is-active");
      item.removeAttribute("aria-hidden");
      item.querySelector("a")?.removeAttribute("tabindex");
    };
    const schedule = () => {
      clearInterval(timer);
      if (!reduce.matches && !paused) timer = setInterval((() => show(index + 1)), interval);
    };
    bar.querySelector("[data-announce-prev]")?.addEventListener("click", (() => {
      show(index - 1);
      schedule();
    }));
    bar.querySelector("[data-announce-next]")?.addEventListener("click", (() => {
      show(index + 1);
      schedule();
    }));
    bar.addEventListener("pointerenter", (() => {
      paused = true;
      schedule();
    }));
    bar.addEventListener("pointerleave", (() => {
      paused = false;
      schedule();
    }));
    bar.addEventListener("focusin", (() => {
      paused = true;
      schedule();
    }));
    bar.addEventListener("focusout", (() => {
      paused = false;
      schedule();
    }));
    document.addEventListener("shopify:block:select", (event => {
      const i = items.findIndex((item => item.contains(event.target) || item === event.target));
      if (i > -1) {
        paused = true;
        show(i);
        schedule();
      }
    }));
    schedule();
  }));
  initBars(document);
  document.addEventListener("shopify:section:load", (event => initBars(event.target)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const toggle = () => {
    const count = window.Vernika && window.Vernika.wishlist ? window.Vernika.wishlist.all().length : 0;
    document.querySelectorAll("[data-wishlist-cta]").forEach((el => el.hidden = count === 0));
  };
  document.addEventListener("wishlist:change", toggle);
  document.addEventListener("cart:updated", toggle);
  document.addEventListener("DOMContentLoaded", toggle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const wide = window.matchMedia("(min-width: 750px)");
  const sync = () => {
    document.querySelectorAll("[data-footer-menu]").forEach((menu => {
      if (wide.matches) menu.setAttribute("open", ""); else menu.removeAttribute("open");
    }));
  };
  sync();
  wide.addEventListener("change", sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  let controller;
  const initHeader = () => {
    controller?.abort();
    controller = new AbortController;
    const signal = controller.signal;
    const wrap = document.querySelector("[data-header]");
    if (!wrap) return;
    const root = document.documentElement;
    const measure = () => {
      const rect = wrap.getBoundingClientRect();
      root.style.setProperty("--header-bottom", `${Math.max(0, rect.bottom)}px`);
    };
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame((() => {
        wrap.classList.toggle("is-scrolled", window.scrollY > 8);
        measure();
        ticking = false;
      }));
    };
    window.addEventListener("scroll", onScroll, {
      passive: true,
      signal: signal
    });
    window.addEventListener("resize", measure, {
      signal: signal
    });
    onScroll();
    const items = [ ...wrap.querySelectorAll("[data-mega-item]") ];
    const canHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    let openItem = null;
    let hoverTimer;
    const setOpen = (item, open) => {
      const button = item.querySelector("[data-mega-toggle]");
      button.setAttribute("aria-expanded", String(open));
      if (open) {
        if (openItem && openItem !== item) setOpen(openItem, false);
        openItem = item;
        measure();
      } else if (openItem === item) {
        openItem = null;
      }
      wrap.classList.toggle("is-mega-open", Boolean(openItem));
    };
    const closeAll = () => openItem && setOpen(openItem, false);
    items.forEach((item => {
      const button = item.querySelector("[data-mega-toggle]");
      button.addEventListener("click", (() => setOpen(item, button.getAttribute("aria-expanded") !== "true")));
      item.addEventListener("pointerenter", (event => {
        if (event.pointerType !== "mouse" || !canHover.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout((() => setOpen(item, true)), openItem ? 0 : 90);
      }));
      item.addEventListener("pointerleave", (event => {
        if (event.pointerType !== "mouse" || !canHover.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout((() => setOpen(item, false)), 180);
      }));
      item.addEventListener("focusout", (event => {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      }));
    }));
    document.addEventListener("keydown", (event => {
      if (event.key === "Escape" && openItem) {
        const button = openItem.querySelector("[data-mega-toggle]");
        closeAll();
        button.focus();
      }
    }), {
      signal: signal
    });
    document.querySelector("[data-mega-scrim]")?.addEventListener("click", closeAll);
    document.addEventListener("dialog:open", closeAll, {
      signal: signal
    });
    const categories = (() => {
      try {
        return JSON.parse(document.getElementById("vernika-categories")?.textContent || "[]");
      } catch {
        return [];
      }
    })();
    const norm = text => text.toLowerCase().trim().replace(/\s+/g, " ").replace(/s$/, "");
    const categoryFor = query => categories.find((c => norm(c.name) === norm(query)));
    document.addEventListener("submit", (event => {
      const form = event.target.closest("[data-category-jump]");
      if (!form) return;
      const query = form.querySelector('input[name="q"]')?.value || "";
      const match = categoryFor(query);
      if (match) {
        event.preventDefault();
        window.location.href = match.url;
      }
    }), {
      signal: signal
    });
    const predictive = (input, resultsBox, popularBox, onShow) => {
      if (!input || !resultsBox || !window.Vernika?.routes?.predictiveSearch) return null;
      let timer;
      let controller;
      const reset = () => {
        controller?.abort();
        resultsBox.replaceChildren();
        resultsBox.hidden = true;
        if (popularBox) popularBox.hidden = false;
        input.setAttribute("aria-expanded", "false");
      };
      const run = async query => {
        controller?.abort();
        controller = new AbortController;
        const url = new URL(window.Vernika.routes.predictiveSearch, window.location.origin);
        url.searchParams.set("q", query);
        url.searchParams.set("resources[type]", "product,collection,query");
        url.searchParams.set("resources[limit]", "6");
        url.searchParams.set("resources[limit_scope]", "each");
        url.searchParams.set("section_id", "predictive-search");
        try {
          resultsBox.setAttribute("aria-busy", "true");
          const html = await fetch(url, {
            signal: controller.signal
          }).then((r => r.text()));
          const content = (new DOMParser).parseFromString(html, "text/html").querySelector(".predictive");
          if (input.value.trim() !== query) return;
          resultsBox.replaceChildren(...content ? [ document.importNode(content, true) ] : []);
          resultsBox.hidden = !content;
          if (popularBox) popularBox.hidden = Boolean(content);
          input.setAttribute("aria-expanded", String(Boolean(content)));
          if (content) onShow?.();
        } catch (error) {
          if (error.name !== "AbortError") reset();
        } finally {
          resultsBox.removeAttribute("aria-busy");
        }
      };
      input.addEventListener("input", (() => {
        clearTimeout(timer);
        const query = input.value.trim();
        if (query.length < 2) {
          reset();
          return;
        }
        timer = setTimeout((() => run(query)), 180);
      }), {
        signal: signal
      });
      input.closest("form, dialog")?.addEventListener("keydown", (event => {
        if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
        const options = [ ...resultsBox.querySelectorAll("[data-predictive-option]") ];
        if (!options.length || resultsBox.hidden) return;
        const index = options.indexOf(document.activeElement);
        event.preventDefault();
        if (event.key === "ArrowDown") options[Math.min(index + 1, options.length - 1)].focus(); else if (index <= 0) input.focus(); else options[index - 1].focus();
      }), {
        signal: signal
      });
      return {
        reset: reset,
        input: input,
        resultsBox: resultsBox
      };
    };
    const searchDrawer = document.getElementById("search-drawer");
    predictive(searchDrawer?.querySelector('input[name="q"]'), searchDrawer?.querySelector("[data-predictive-results]"), searchDrawer?.querySelector("[data-popular-searches]"));
    const pill = document.querySelector("[data-hdr-search]");
    const pillSearch = predictive(pill?.querySelector('input[name="q"]'), pill?.querySelector("[data-predictive-results]"), null, closeAll);
    if (pill && pillSearch) {
      const hide = () => {
        pillSearch.resultsBox.hidden = true;
        pillSearch.input.setAttribute("aria-expanded", "false");
      };
      document.addEventListener("click", (event => {
        if (!pill.contains(event.target)) hide();
      }), {
        signal: signal
      });
      pill.addEventListener("keydown", (event => {
        if (event.key === "Escape") {
          hide();
          pillSearch.input.focus();
        }
      }), {
        signal: signal
      });
      pillSearch.input.addEventListener("focus", (() => {
        if (pillSearch.resultsBox.childElementCount && pillSearch.input.value.trim().length >= 2) {
          pillSearch.resultsBox.hidden = false;
          pillSearch.input.setAttribute("aria-expanded", "true");
        }
      }), {
        signal: signal
      });
    }
    const drawer = document.getElementById("wishlist-drawer");
    if (!drawer || !window.Vernika) return;
    const V = window.Vernika;
    const s = V.strings || {};
    const list = drawer.querySelector("[data-wishlist-items]");
    const empty = drawer.querySelector("[data-wishlist-empty]");
    const titleCount = drawer.querySelector("[data-wishlist-title-count]");
    const cache = new Map;
    const GONE = "gone";
    const fetchProduct = handle => {
      if (!cache.has(handle)) {
        const request = fetch(`${V.routes.root.replace(/\/$/, "")}/products/${encodeURIComponent(handle)}.js`).then((r => {
          if (r.status === 404) return GONE;
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.json();
        })).catch((() => {
          cache.delete(handle);
          return null;
        }));
        cache.set(handle, request);
      }
      return cache.get(handle);
    };
    const sized = (src, width) => {
      if (!src) return "";
      const url = new URL(src, window.location.href);
      url.searchParams.set("width", width);
      return url.toString();
    };
    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const line = product => {
      const item = el("li", "wish-line");
      const media = el("a", "wish-line__media");
      media.href = product.url;
      media.tabIndex = -1;
      media.setAttribute("aria-hidden", "true");
      if (product.featured_image) {
        const img = el("img");
        img.src = sized(product.featured_image, 240);
        img.alt = "";
        img.loading = "lazy";
        img.width = 88;
        img.height = 110;
        media.append(img);
      }
      const info = el("div", "wish-line__info");
      const top = el("div", "line-item__top");
      const title = el("a", "line-item__title", product.title);
      title.href = product.url;
      const remove = el("button", "line-item__remove");
      remove.type = "button";
      remove.dataset.wishlistRemove = product.handle;
      remove.setAttribute("aria-label", (s.wishlistRemoveLabel || "Remove %TITLE%").replace("%TITLE%", product.title));
      remove.innerHTML = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
      top.append(title, remove);
      const price = el("div", `price price--sm${product.compare_at_price > product.price ? " price--sale" : ""}`);
      price.append(el("span", "price__now", V.money(product.price)));
      if (product.compare_at_price > product.price) price.append(el("s", "price__was", V.money(product.compare_at_price)));
      const actions = el("div", "wish-line__actions");
      const firstAvailable = product.variants.find((v => v.available));
      if (!product.available) {
        actions.append(el("span", "badge badge--soldout", s.soldOut || "Sold out"));
      } else if (product.variants.length === 1 && firstAvailable) {
        const add = el("button", "btn btn--dark btn--sm", s.addToBag || "Add to bag");
        add.type = "button";
        add.dataset.quickAdd = "";
        add.dataset.variantId = firstAvailable.id;
        actions.append(add);
      } else {
        const choose = el("a", "btn btn--outline btn--sm", s.chooseSize || "Choose size");
        choose.href = product.url;
        actions.append(choose);
      }
      info.append(top, price, actions);
      item.append(media, info);
      return item;
    };
    const render = async () => {
      const handles = V.wishlist.all().filter((h => !h.startsWith("placeholder-")));
      titleCount.textContent = handles.length ? `(${handles.length})` : "";
      empty.hidden = handles.length > 0;
      if (!handles.length) {
        list.replaceChildren();
        return;
      }
      list.setAttribute("aria-busy", "true");
      const products = await Promise.all(handles.map(fetchProduct));
      const missing = handles.filter(((_, i) => products[i] === GONE));
      if (missing.length) V.wishlist.save(V.wishlist.all().filter((h => !missing.includes(h))));
      list.replaceChildren(...products.filter((p => p && p !== GONE)).map(line));
      list.removeAttribute("aria-busy");
    };
    drawer.addEventListener("dialog:open", render);
    document.addEventListener("wishlist:change", (() => drawer.open && render()), {
      signal: signal
    });
    drawer.addEventListener("click", (event => {
      const remove = event.target.closest("[data-wishlist-remove]");
      if (remove) V.wishlist.remove(remove.dataset.wishlistRemove);
    }));
  };
  initHeader();
  document.addEventListener("shopify:section:load", (event => {
    if (event.target.querySelector("[data-header]")) initHeader();
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = hero => {
    if (hero.dataset.ready) return;
    hero.dataset.ready = "";
    const track = hero.querySelector("[data-hero-track]");
    const slides = [ ...track.children ];
    const dots = [ ...hero.querySelectorAll("[data-hero-dot]") ];
    const pause = hero.querySelector("[data-hero-pause]");
    if (slides.length < 2) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    const interval = Number(hero.dataset.autoplay) || 0;
    let index = 0;
    let timer;
    let userPaused = reduce.matches;
    let hovering = false;
    if (pause && userPaused) hero.setAttribute("data-paused", "");
    const go = i => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[index].offsetLeft,
        behavior: reduce.matches ? "auto" : "smooth"
      });
    };
    const mark = i => {
      index = i;
      dots.forEach(((dot, n) => dot.setAttribute("aria-current", String(n === i))));
      slides.forEach(((slide, n) => {
        slide.querySelectorAll("[data-hero-focusable]").forEach((el => {
          if (n === i) el.removeAttribute("tabindex"); else el.setAttribute("tabindex", "-1");
        }));
      }));
    };
    const observer = new IntersectionObserver((entries => {
      entries.forEach((entry => {
        if (entry.isIntersecting && entry.intersectionRatio > .6) mark(slides.indexOf(entry.target));
      }));
    }), {
      root: track,
      threshold: [ .6 ]
    });
    slides.forEach((slide => observer.observe(slide)));
    const schedule = () => {
      clearInterval(timer);
      if (interval && !userPaused && !hovering && !document.hidden) timer = setInterval((() => go(index + 1)), interval);
    };
    dots.forEach((dot => dot.addEventListener("click", (() => {
      go(Number(dot.dataset.heroDot));
      schedule();
    }))));
    hero.querySelector("[data-hero-prev]")?.addEventListener("click", (() => {
      go(index - 1);
      schedule();
    }));
    hero.querySelector("[data-hero-next]")?.addEventListener("click", (() => {
      go(index + 1);
      schedule();
    }));
    pause?.addEventListener("click", (() => {
      userPaused = !userPaused;
      hero.toggleAttribute("data-paused", userPaused);
      pause.setAttribute("aria-label", userPaused ? pause.dataset.labelPlay : pause.dataset.labelPause);
      schedule();
    }));
    hero.addEventListener("pointerenter", (e => {
      if (e.pointerType === "mouse") {
        hovering = true;
        schedule();
      }
    }));
    hero.addEventListener("pointerleave", (e => {
      if (e.pointerType === "mouse") {
        hovering = false;
        schedule();
      }
    }));
    hero.addEventListener("focusin", (() => {
      hovering = true;
      schedule();
    }));
    hero.addEventListener("focusout", (() => {
      hovering = false;
      schedule();
    }));
    track.addEventListener("pointerdown", (() => clearInterval(timer)));
    track.addEventListener("pointerup", (() => setTimeout(schedule, 800)));
    track.addEventListener("scrollend", schedule);
    document.addEventListener("visibilitychange", schedule);
    document.addEventListener("shopify:block:select", (event => {
      const i = slides.indexOf(event.target);
      if (i > -1) {
        userPaused = true;
        go(i);
        schedule();
      }
    }));
    schedule();
  };
  document.querySelectorAll("[data-hero]").forEach(init);
  document.addEventListener("shopify:section:load", (event => event.target.querySelectorAll("[data-hero]").forEach(init)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll("[data-hhero]").forEach((hero => {
    const slides = [ ...hero.querySelectorAll("[data-slide]") ];
    const cards = [ ...hero.querySelectorAll("[data-card]") ];
    const bars = [ ...hero.querySelectorAll(".hhero__bars i") ];
    if (slides.length < 2) return;
    const wait = Number(hero.dataset.interval) || 4e3;
    hero.style.setProperty("--hhero-t", `${wait}ms`);
    const still = matchMedia("(prefers-reduced-motion: reduce)");
    let cur = 0;
    let timer;
    const show = n => {
      slides.forEach(((s, i) => {
        const on = i === n;
        s.classList.toggle("is-on", on);
        s.setAttribute("aria-hidden", on ? "false" : "true");
        s.tabIndex = on ? 0 : -1;
      }));
      bars.forEach(((b, i) => {
        b.classList.toggle("is-on", i === n);
        b.classList.toggle("is-done", i < n);
      }));
      const next = cards[n];
      const prev = cards.find((c => !c.hidden));
      if (prev && prev !== next) {
        prev.classList.add("is-swapping");
        setTimeout((() => {
          prev.hidden = true;
          prev.classList.remove("is-swapping");
          if (next) next.hidden = false;
        }), 350);
      } else if (next) next.hidden = false;
      cur = n;
    };
    const play = () => {
      clearInterval(timer);
      if (!still.matches) timer = setInterval((() => show((cur + 1) % slides.length)), wait);
    };
    if (!still.matches) hero.setAttribute("data-moving", "");
    show(0);
    play();
    hero.addEventListener("mouseenter", (() => clearInterval(timer)));
    hero.addEventListener("mouseleave", play);
    hero.addEventListener("focusin", (() => clearInterval(timer)));
    hero.addEventListener("focusout", play);
    document.addEventListener("visibilitychange", (() => document.hidden ? clearInterval(timer) : play()));
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fmt = t => {
    t = Math.max(0, Math.floor(t || 0));
    return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
  };
  const start = scope => scope.querySelectorAll("[data-vplayer]").forEach((box => {
    if (box.dataset.ready) return;
    box.dataset.ready = "1";
    const video = box.querySelector("video");
    const seek = box.querySelector("[data-vp-seek]");
    const time = box.querySelector("[data-vp-time]");
    const vol = box.querySelector("[data-vp-vol]");
    const muteBtn = box.querySelector("[data-vp-mute]");
    const toggles = box.querySelectorAll("[data-vp-toggle]");
    const toggle = () => video.paused ? video.play() : video.pause();
    toggles.forEach((b => b.addEventListener("click", toggle)));
    video.addEventListener("click", toggle);
    const sync = () => {
      const playing = !video.paused && !video.ended;
      box.classList.toggle("is-playing", playing);
      box.classList.toggle("is-muted", video.muted || video.volume === 0);
      toggles.forEach((b => b.setAttribute("aria-label", playing ? "Pause video" : "Play video")));
      muteBtn.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
    };
    video.addEventListener("play", (() => {
      box.classList.add("has-started");
      document.querySelectorAll("[data-vplayer] video").forEach((v => {
        if (v !== video) v.pause();
      }));
      sync();
    }));
    [ "pause", "ended", "volumechange" ].forEach((e => video.addEventListener(e, sync)));
    video.addEventListener("timeupdate", (() => {
      if (video.duration) seek.value = Math.round(video.currentTime / video.duration * 1e3);
      time.textContent = fmt(video.currentTime);
    }));
    video.addEventListener("loadedmetadata", (() => {
      time.textContent = fmt(video.duration);
    }));
    seek.addEventListener("input", (() => {
      if (video.duration) video.currentTime = seek.value / 1e3 * video.duration;
    }));
    vol.addEventListener("input", (() => {
      video.volume = Number(vol.value);
      video.muted = video.volume === 0;
    }));
    muteBtn.addEventListener("click", (() => {
      video.muted = !video.muted;
      if (!video.muted && video.volume === 0) {
        video.volume = .6;
        vol.value = .6;
      }
    }));
    try {
      video.volume = .5;
      if (video.volume !== .5) box.classList.add("no-volume");
      video.volume = 1;
    } catch {
      box.classList.add("no-volume");
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries => entries.forEach((e => {
        if (!e.isIntersecting && !video.paused) video.pause();
      }))), {
        threshold: .2
      }).observe(box);
    }
    sync();
  }));
  start(document);
  document.addEventListener("shopify:section:load", (e => start(e.target)));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
(() => {
  const still = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const playWhenSeen = root => {
    const io = new IntersectionObserver((entries => {
      entries.forEach((({target: target, isIntersecting: isIntersecting}) => {
        if (isIntersecting) {
          target.muted = true;
          if (target.preload === "none") target.preload = "metadata";
          target.play().catch((() => {}));
        } else {
          target.pause();
        }
      }));
    }), {
      threshold: .2
    });
    root.querySelectorAll("video").forEach((v => {
      v.muted = true;
      v.setAttribute("playsinline", "");
      io.observe(v);
    }));
  };
  document.querySelectorAll("[data-reels-strip]").forEach((strip => {
    const track = strip.querySelector("[data-reels-track]");
    const originals = [ ...track.children ];
    if (!originals.length) return;
    if (still) {
      playWhenSeen(strip);
      return;
    }
    const clone = li => {
      const c = li.cloneNode(true);
      c.setAttribute("aria-hidden", "true");
      c.querySelectorAll("a").forEach((a => a.setAttribute("tabindex", "-1")));
      return c;
    };
    const build = () => {
      track.querySelectorAll('[aria-hidden="true"]').forEach((c => c.remove()));
      strip.classList.remove("is-looping");
      track.style.removeProperty("--reel-dist");
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const setWidth = () => originals.reduce(((w, li) => w + li.getBoundingClientRect().width + gap), 0);
      const one = setWidth();
      if (!one) return;
      const copies = Math.max(1, Math.ceil(strip.clientWidth / one));
      const row = [];
      for (let k = 1; k < copies; k += 1) originals.forEach((li => row.push(clone(li))));
      row.forEach((c => track.appendChild(c)));
      const rowItems = [ ...track.children ];
      rowItems.forEach((li => track.appendChild(clone(li))));
      const dist = one * copies;
      const speed = Number(strip.dataset.speed) || 40;
      strip.style.setProperty("--reel-dist", `${dist}px`);
      strip.style.setProperty("--reel-time", `${dist / speed}s`);
      strip.classList.add("is-looping");
    };
    build();
    playWhenSeen(strip);
    new IntersectionObserver((([e]) => strip.classList.toggle("is-running", e.isIntersecting)), {
      threshold: .15
    }).observe(strip);
    let t;
    let lastW = innerWidth;
    addEventListener("resize", (() => {
      if (innerWidth === lastW) return;
      lastW = innerWidth;
      clearTimeout(t);
      t = setTimeout((() => {
        build();
        playWhenSeen(strip);
      }), 250);
    }));
  }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
document.addEventListener("click", (async event => {
  const button = event.target.closest("[data-copy-link]");
  if (!button) return;
  try {
    await navigator.clipboard.writeText(button.dataset.copyLink);
    window.Vernika?.toast?.(button.dataset.copied);
  } catch {}
}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const setup = () => {
    document.querySelectorAll("[data-clamp]").forEach((desc => {
      const toggle = desc.nextElementSibling;
      if (!toggle || !toggle.matches("[data-clamp-toggle]") || desc.dataset.ready) return;
      desc.dataset.ready = "";
      desc.classList.add("is-clamped");
      if (desc.scrollHeight - desc.clientHeight < 4) {
        desc.classList.remove("is-clamped");
        return;
      }
      toggle.hidden = false;
      toggle.addEventListener("click", (() => {
        const clamped = desc.classList.toggle("is-clamped");
        toggle.textContent = clamped ? toggle.dataset.labelMore : toggle.dataset.labelLess;
      }));
    }));
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", setup); else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
(() => {
  const open = () => {
    if (document.querySelector("[data-password-error]") && window.Vernika?.openDialog) window.Vernika.openDialog("password-dialog");
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", open); else open();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
(() => {
  const start = async () => {
    const root = document.querySelector("[data-wishlist-page]");
    const V = window.Vernika;
    if (!root || root.dataset.ready || !V || !V.renderCard) return;
    root.dataset.ready = "";
    const s = JSON.parse(document.querySelector("[data-wl-strings]")?.textContent || "{}");
    const grid = root.querySelector("[data-wl-grid]");
    const empty = root.querySelector("[data-wl-empty]");
    const count = root.querySelector("[data-wl-count]");
    const share = root.querySelector("[data-wl-share]");
    const saveShared = root.querySelector("[data-wl-save-shared]");
    const title = root.querySelector("[data-wl-title]");
    const params = new URLSearchParams(window.location.search);
    const shared = (params.get("items") || "").split(",").map((h => h.trim())).filter((h => /^[a-z0-9-]+$/.test(h))).slice(0, 50);
    const isShared = shared.length > 0;
    if (isShared) {
      title.textContent = title.dataset.titleShared;
      saveShared.hidden = false;
    }
    const render = async () => {
      const handles = isShared ? shared : V.wishlist.all().filter((h => !h.startsWith("placeholder-"))).slice(0, 50);
      const products = (await Promise.all(handles.map((h => V.fetchProduct(h).catch((() => null)))))).filter(Boolean);
      grid.removeAttribute("aria-busy");
      grid.replaceChildren(...products.map((p => {
        const li = document.createElement("li");
        li.append(V.renderCard(p));
        return li;
      })));
      empty.hidden = products.length > 0;
      grid.hidden = products.length === 0;
      share.hidden = isShared || products.length === 0;
      const template = isShared ? s.sharedCount : products.length === 1 ? s.countOne : s.count;
      count.textContent = products.length ? String(template || "").replace("%COUNT%", products.length) : "";
      V.syncWishlist?.();
    };
    share.addEventListener("click", (async () => {
      const url = new URL(window.location.href);
      url.search = "";
      url.searchParams.set("items", V.wishlist.all().filter((h => !h.startsWith("placeholder-"))).join(","));
      try {
        if (navigator.share) await navigator.share({
          title: share.dataset.shareTitle,
          url: url.toString()
        }); else {
          await navigator.clipboard.writeText(url.toString());
          V.toast(share.dataset.copied);
        }
      } catch {}
    }));
    saveShared.addEventListener("click", (() => {
      const mine = V.wishlist.all();
      V.wishlist.save([ ...shared.filter((h => !mine.includes(h))), ...mine ]);
      V.toast(s.saved);
    }));
    if (!isShared) document.addEventListener("wishlist:change", render);
    await render();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const load = async box => {
    if (box.dataset.loaded) return;
    box.dataset.loaded = "";
    try {
      const html = await fetch(box.dataset.url).then((r => r.text()));
      const fresh = (new DOMParser).parseFromString(html, "text/html").querySelector("[data-recommendations]");
      if (!fresh || !fresh.innerHTML.trim()) {
        box.closest(".shopify-section")?.setAttribute("hidden", "");
        return;
      }
      box.innerHTML = fresh.innerHTML;
      window.Vernika?.initScrollers?.(box);
      window.Vernika?.syncWishlist?.();
    } catch {
      box.closest(".shopify-section")?.setAttribute("hidden", "");
    }
  };
  const watch = scope => {
    scope.querySelectorAll("[data-recommendations]").forEach((box => {
      if (box.querySelector(".scroller")) return;
      const observer = new IntersectionObserver((entries => {
        if (entries.some((e => e.isIntersecting))) {
          observer.disconnect();
          load(box);
        }
      }), {
        rootMargin: "600px 0px"
      });
      observer.observe(box);
    }));
  };
  watch(document);
  document.addEventListener("shopify:section:load", (event => watch(event.target)));
})();

  } catch(e) { console.error(e); }
})();
})();
